import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const Container = ({ rendering }) => {
  if (!rendering?.params) {
    return <GenericPlaceholder componentName="Container" />;
  }
  const style = rendering?.params?.Styles;

  return (
    <div className={clsx('content', 'add-margins', style)}>
      <Placeholder name="jss-container" rendering={rendering} />
    </div>
  );
};

export default Container;
